<template>
    <div class="x-field" :class="fieldClass">
        <div class="x-input" :class="{'x-input-error': !!error}">
            <label class="x-label" :class="labelClass" v-if="!!label">{{ label }}
                <slot name="label"></slot>
                <el-tooltip :content="tooltipContent"
                            effect="dark"
                            placement="top-end"
                            v-if="!!tooltipContent">
                    <i class="fa fa-info-circle"></i>
                </el-tooltip>
            </label>
            <div style="display: flex">
                <el-input :class="{'x-input-readonly': readonly, 'with-button-new': showButtonNew}"
                          :value="value"
                          :maxlength="maxlength"
                          :placeholder="placeholder"
                          @input="handleInput($event)"
                          @focus="$emit('focus', $event)"
                          :type="type" :name="name" :readonly="readonly">
                    <template v-if="textPrepend" slot="prepend">{{ textPrepend }}</template>
                </el-input>
                <x-button-icon :icon="iconButton"
                               type="primary"
                               @click="$emit('click-button')"
                               v-if="showButtonNew"></x-button-icon>
            </div>
            <small v-if="textError !== ''" class="x-label-error" v-text="textError"></small>
        </div>
    </div>
</template>

<script>
import XButtonIcon from "./XButtonIcon.vue";

export default {
    name: 'XInput',
    components: {XButtonIcon},
    props: {
        value: {
            default: ''
        },
        type: {
            type: String,
            default: 'text'
        },
        label: {
            type: String,
            default: null,
        },
        placeholder: {
            type: String,
            default: null,
        },
        name: {
            type: String,
            default: '',
        },
        error: {
            default: null,
        },
        readonly: {
            type: Boolean,
            default: false,
        },
        tooltipContent: {
            type: String,
            default: null,
        },
        textPrepend: {
            type: String,
            default: null,
        },
        labelClass: {
            type: String,
            default: null,
        },
        fieldClass: {
            type: String,
            default: null,
        },
        showButtonNew: {
            type: Boolean,
            default: false
        },
        iconButton: {
            type: String,
            default: 'fal fa-plus',
        },
        maxlength: {
            default: 250,
        }
    },
    data() {
        return {}
    },
    computed: {
        textError() {
            if (!_.isNull(this.error)) {
                return this.error[0];
            }
            return '';
        }
    },
    methods: {
        handleInput(value) {
            this.$emit('input', value)
        }
    }
}
</script>
